export const config = {
  name: 'insurance-claim-web',
  publicPath: '/meld-skade/'
} as const;
